import React from 'react';


/**
 * Modal section that displays errors to user.
 *
 * @param props.title String that contains the title of the error box.
 * @param props.body String that contains the body text of the error box.
 * @param props.insightMessage String that contains any additional insightful message.
 * @return JSX
 */
export function CdaWebModalErrorBox(props) {
    const {title, body} = props;

    return (
      <div className="cdaWebModalErrorBox">
        <h2>{title}</h2>
        <div className="cdaWebModalPlotErrorMessageWithStatus">
          {body.split('|n|').map(el=>(el.slice(0,3) !== "|t|" ? <div>{el}</div> : <div>&emsp;{el.replace("|t|","")}</div>))}
        </div>
      </div>
    )
}
